import { LicenseInfoTypeFragment } from '@entities/billing';

export type ModalLicenseType = LicenseInfoTypeFragment & {
  isChecked: boolean;
};

export const getModalLicenseItem = (
  item: LicenseInfoTypeFragment,
  toSuspendAutorenewal: string[],
  toEnableAutorenewal: string[]
): ModalLicenseType => {
  const isInSuspendAutorenewal = toSuspendAutorenewal.indexOf(item.id) > -1;
  const isInEnableAutorenewal = toEnableAutorenewal.indexOf(item.id) > -1;
  const isChecked = isInEnableAutorenewal || (isInSuspendAutorenewal ? false : item.autoRenewal);

  return {
    ...item,
    isChecked,
  };
};
